import store from '@/store';
import { CHANGE_JUMP_QIDENTIFIER } from '@/libs/constant';
import {
    OptionJumpType,
    OptionType,
    QuestionRequire,
    QuestionSepcialFlag,
    QuestionType
} from '@/libs/enum';
import {
    setBerelQuestions,
    haveQuestionRel,
    checkQuestionRelOK,
    checkGroupExistShow,
    getMaxPageNum,
    getQuestions,
    getQuestionById,
    hasAnswer,
    checkRefShow,
    questionJump
} from './question-util';

/**
 * 问卷分组
 * @param {问卷题目} questions
 */
export const pageByGroup = questions => {
    if (!questions || !questions.length) {
        return {};
    }
    const page = {};
    let pageList = [];
    let currentPage = 1;
    questions.forEach((question, index) => {
        // 默认题目都是显示
        question.show = true;
        // 初始化被关联
        question.berelConfigs = [];
        if (QuestionType.page === question.questionType) {
            page[currentPage] = pageList;
            pageList = [];
            currentPage += 1;
        } else {
            // 有关联关系
            const haveRel = haveQuestionRel(question);
            if (haveRel) {
                // 配置上指定了需要符合关联关系才不显示，所以默认应该是显示
                if (question.questionRelConfig.visible === false) {
                    question.show = true;
                } else {
                    question.show = false;
                }
                setBerelQuestions(questions, question);
            }
            pageList.push(question);
        }
        if (index === questions.length - 1 && QuestionType.page !== question.questionType) {
            // 最后一个 非分页类型的需要存储
            page[currentPage] = pageList;
        }
    });
    return page;
};

/**
 * 检测当前分页对象每页都是单挑数据
 * @param {分页对象} page
 */
export const checkIsSinglePage = page => {
    if (!page) {
        return false;
    }
    let isSingle = true;
    const keys = Object.keys(page);
    for (let i = 0; i < keys.length; i++) {
        const group = page[keys[i]];
        if (Array.isArray(group) && group.length > 1) {
            isSingle = false;
            break;
        }
    }
    return isSingle;
};

/**
 * 查找题目唯一标志在分页索引
 * @param {题目的唯一标志} qidentifier
 */
export const findPageIdex = (qidentifier, page) => {
    if (!page || !qidentifier) {
        return null;
    }
    const keys = Object.keys(page);
    let pageKey = null;
    for (let i = 0; i < keys.length; i++) {
        const group = page[keys[i]];
        const find = group.find(question => question.qidentifier === qidentifier);
        if (find) {
            pageKey = keys[i];
            break;
        }
    }
    return pageKey;
};

/**
 * 查找题目索引查找分页索引
 * @param {题目的唯一标志} qidentifier
 */
export const find2PageIdex = (questionIndex, page) => {
    if (!page || !questionIndex) {
        return null;
    }
    const keys = Object.keys(page);
    let pageKey = null;
    for (let i = 0; i < keys.length; i++) {
        const group = page[keys[i]];
        const find = group.find(question => question.questionIndex === questionIndex);
        if (find) {
            pageKey = keys[i];
            break;
        }
    }
    return pageKey;
};

/**
 * 查询分组中问题的位置索引
 * @param {*} groupQuestionList 分组问题列表
 * @param {*} questionIndex 问题索引
 * @returns
 */
export const findQuestionIndex = (groupQuestionList, qidentifier) => {
    const index = groupQuestionList.findIndex(question => question.qidentifier === qidentifier);
    return index;
};

/**
 *
 * @param {*} page 分页组合
 * @param {*} sourceQuestionIndex 源问题索引
 * @param {*} targetQuestionIndex 查询的目标问题索引
 */
export const isSamePage = (page, sourceQidentifier, targetQidentifier) => {
    const sourcePageKey = findPageIdex(sourceQidentifier, page);
    const targetPageKey = findPageIdex(targetQidentifier, page);
    return sourcePageKey === targetPageKey;
};

const groupDisplay = (group = [], isShow) => {
    for (let i = 0; i < group.length; i++) {
        const question = group[i];
        question.show = isShow;
    }
    return group;
};

/**
 * 当答题是每页一个题目的时候的分页
 * @param {*} page 所有分页
 * @param {*} currentPage 当前分页
 */
export const jumpSinglePage = (page, currentPage, jumpQidentifier, toEnd) => {
    const allPage = Object.keys(page).length;
    const current = Number(currentPage);
    const groupData = {
        group: [],
        pageNum: current
    };
    if (toEnd) {
        const jumpTargetPage = allPage + 1;
        for (let i = current + 1; i < jumpTargetPage; i++) {
            let group = page[i];
            if (group && Array.isArray(group)) {
                group = groupDisplay(group, false);
            }
        }
        groupData.group = [];
        groupData.pageNum = allPage;
        return groupData;
    }
    // 没有配置跳题逻辑，返回下一页的题目
    let jumpTargetPage = current;
    if (jumpQidentifier === undefined || jumpQidentifier === null) {
        jumpTargetPage += 1;
    } else {
        // 跳转到目标数据中间数据隐藏
        jumpTargetPage = Number(findPageIdex(jumpQidentifier, page));
        for (let i = current + 1; i < jumpTargetPage; i++) {
            let group = page[i];
            if (group && Array.isArray(group)) {
                group = groupDisplay(group, false);
            }
        }
    }
    // 跳转到的数据设置show
    let group = page[jumpTargetPage];
    while (!checkGroupExistShow(group) && jumpTargetPage <= allPage) {
        jumpTargetPage += 1;
        group = page[jumpTargetPage];
    }
    groupData.group = group || [];
    groupData.pageNum = jumpTargetPage > allPage ? allPage : jumpTargetPage;
    return groupData;
};

/**
 * 从当前答题的索引开始到当前页的最后一题，没有引用关系的所有题目都显示
 * @param {*} group
 * @param {*} startIndex
 * @returns
 */
export const recoveGroup = (group, startIndex) => {
    for (let i = startIndex + 1; i < group.length; i++) {
        const question = group[i];
        if (!haveQuestionRel(question)) {
            question.show = true;
        }
    }
    return group;
};

/**
 * 跳转到结束，从当前题目到结束的所有题目，判断后续的题目是应该显示还是隐藏
 * @param {*} page
 * @param {*} currentPage
 * @param {*} currentQidentifier
 * @param {*} isShow 默认显示，题目的具体显示根据它是否有引用关系
 */
function pageToEnd(page, currentPage, currentQidentifier, isShow) {
    const currentPageNum = Number(currentPage);
    const maxPageNum = getMaxPageNum(page);
    let currentGroup = [];
    for (let num = currentPageNum; num <= maxPageNum; num++) {
        const group = page[num] || [];
        let loopIndex = 0;
        if (num === currentPageNum) {
            // 当前页面，从选中的题目的下一道题进行便利
            const currentIndex = findQuestionIndex(group, currentQidentifier);
            loopIndex = currentIndex + 1;
        }
        // 遍历从当前页面开始，剩下的页面是否应该应该被显示
        for (let i = loopIndex; i < group.length; i++) {
            const question = group[i];
            if (isShow) {
                // 清空当前页面，当前题目后续的所有问题的答案
                // question.anwser = question.questionType === QuestionType.multi ? [] : '';
                // 没有关联关系，或者是关联关系符合都应该显示
                if (!haveQuestionRel(question)) {
                    question.show = true;
                }
            } else {
                question.show = false;
            }
        }
        if (num === currentPageNum) {
            currentGroup = group;
        }
    }
    // 返回当前页面应该显示的题目
    return currentGroup;
}

// 关闭显示到结束
export function jumpToPageEnd(page, currentPage, currentQidentifier) {
    return pageToEnd(page, currentPage, currentQidentifier, false);
}

// 显示到结束
export function displayToEnd(page, currentPage, currentQidentifier) {
    return pageToEnd(page, currentPage, currentQidentifier, true);
}

/**
 * 一页多题目的跳题逻辑
 * @param {*} page
 * @param {*} currentPage
 * @param {*} jumpQidentifier
 */
export const jumpMultiPage = (page, currentPage, currentQidentifier, jumpQidentifier) => {
    let group = page[currentPage];
    const currentQidentifierIndex = findQuestionIndex(group, currentQidentifier);
    // 显示当前页从当前题目到题目结尾都显示
    group = recoveGroup(group, currentQidentifierIndex);
    const { jumpQidentifierCollect } = store.state;
    if (!jumpQidentifier) {
        store.commit(CHANGE_JUMP_QIDENTIFIER, { ...jumpQidentifierCollect, [currentPage]: null });
        return group;
    }
    // 判断跳题是否在同一页
    const samePage = isSamePage(page, currentQidentifier, jumpQidentifier);
    if (samePage) {
        store.commit(CHANGE_JUMP_QIDENTIFIER, { ...jumpQidentifierCollect, [currentPage]: null });
        // 在同一页
        const currentQidentifierIndex = findQuestionIndex(group, currentQidentifier);
        const targetQidentifierIndex = findQuestionIndex(group, jumpQidentifier);
        for (let i = currentQidentifierIndex + 1; i < targetQidentifierIndex; i++) {
            const question = group[i];
            question.show = false;
        }
    } else {
        store.commit(CHANGE_JUMP_QIDENTIFIER, {
            ...jumpQidentifierCollect,
            [currentPage]: jumpQidentifier
        });
        const curIndex = findQuestionIndex(group, currentQidentifier);
        for (let j = curIndex + 1; j < group.length; j++) {
            const qn = group[j];
            qn.show = false;
        }
    }
    return group;
};

/**
 * 一页多题目，跳题翻页时候，存在前几道题需要隐藏
 * @param {*} jumpPage
 * @param {*} startQidentifier
 */
export const getMultiNextGroup = (group, startQidentifier) => {
    const curIndex = findQuestionIndex(group, startQidentifier);
    for (let i = 0; i < curIndex; i++) {
        const question = group[i];
        question.show = false;
    }
    return group;
};

export const validateQuestionOption = option => {
    if (!option) {
        return true;
    }
    // 选项没有启用选择+填空题，则认为通过校验
    if (option.optionType !== OptionType.checkAndFillbank) {
        return true;
    }
    // 选项中非必填 校验通过
    if (option.optionConstraint && !option.optionConstraint.required) {
        return true;
    }
    // 选项必填 必填项存在数据 校验通过
    if (option.optionConstraint && option.optionConstraint.required && option.inputValue) {
        return true;
    }
    return false;
};

/**
 * 验证当前页的必填
 * @param {*} group
 * @returns
 */
export const validatorQuestion = group => {
    const validate = {
        qidentifier: '',
        optionIdentifier: ''
    };
    if (!group || !group.length) {
        return validate;
    }
    for (let i = 0; i < group.length; i++) {
        const question = group[i];
        if (question.requireFlag === QuestionRequire.yes && question.show) {
            // 题目未填写答案，优先校验答案。答案填写了，校验答案对应的选项填空是否必填
            if (!question.anwser || !question.anwser.length) {
                validate.qidentifier = question.qidentifier;
                break;
            } else if (question.questionType === QuestionType.single) {
                // 根据选项答案找选项
                const option = question.questionOptions.find(
                    opt => opt.optionIdentifier === question.anwser
                );
                const isvalidateOption = validateQuestionOption(option);
                if (!isvalidateOption) {
                    validate.qidentifier = question.qidentifier;
                    validate.optionIdentifier = option.optionIdentifier;
                    break;
                }
            } else if (question.questionType === QuestionType.multi) {
                const answerList = question.anwser;
                for (let j = 0; j < answerList.length; j++) {
                    const option = question.questionOptions.find(
                        opt => opt.optionIdentifier === answerList[j]
                    );
                    const isvalidateOption = validateQuestionOption(option);
                    if (!isvalidateOption) {
                        validate.qidentifier = question.qidentifier;
                        validate.optionIdentifier = option.optionIdentifier;
                        break;
                    }
                }
            } else {
                // not do anything
            }
        }
    }
    return validate;
};

/**
 * 答案提取 - 获取所有的答案
 * @param {*} page
 */
export const getAllAnswer = (page = {}) => {
    const questionAnswers = [];
    Object.keys(page).forEach(key => {
        if (Object.hasOwnProperty.call(page, key)) {
            const group = page[key];
            if (group && Array.isArray(group)) {
                for (let i = 0; i < group.length; i++) {
                    const question = group[i];
                    if (question.show && question.anwser) {
                        const questionAnswer = {
                            qidentifier: '',
                            optionAnswers: []
                        };
                        questionAnswer.qidentifier = question.qidentifier;
                        if (question.questionType === QuestionType.single) {
                            const optAnswer = {
                                optionIdentifier: question.anwser
                            };
                            const findOpt = question.questionOptions.find(
                                option => option.optionIdentifier === question.anwser
                            );
                            if (findOpt) {
                                optAnswer.answerContent = findOpt.inputValue || '';
                            }
                            questionAnswer.optionAnswers = [optAnswer];
                        } else if (question.questionType === QuestionType.multi) {
                            const optionAnswers = (question.anwser || []).map(optionIdentifier => {
                                const answers = {
                                    optionIdentifier,
                                    answerContent: ''
                                };
                                const findOpt = question.questionOptions.find(
                                    option => option.optionIdentifier === optionIdentifier
                                );
                                if (findOpt) {
                                    answers.answerContent = findOpt.inputValue;
                                }
                                return answers;
                            });
                            questionAnswer.optionAnswers = optionAnswers;
                        } else if (question.questionType === QuestionType.fillblank) {
                            let fileUrlString = '';
                            if (question.fileUrls && question.fileUrls.length) {
                                fileUrlString = `||${question.fileUrls.join('||')}`;
                            }
                            questionAnswer.optionAnswers = [
                                {
                                    answerContent: question.anwser + fileUrlString,
                                    optionIdentifier:
                                        question.questionOptions[0] &&
                                        question.questionOptions[0].optionIdentifier
                                }
                            ];
                        }
                        questionAnswers.push(questionAnswer);
                    }
                }
            }
        }
    });
    return questionAnswers;
};

/**
 * 判断当前问卷分组题目是否已经全部回答
 * @param {*} group
 * @returns
 */
export const judgeGroupHaveAnswer = (group = []) => {
    let haveAnswer = true;
    for (let i = 0; i < group.length; i++) {
        const question = group[i];
        // 仅对展示的题目和必填的题目校验是否有答案
        if (question.show && question.requireFlag === QuestionRequire.yes) {
            if (!question.anwser || !question.anwser.length) {
                haveAnswer = false;
                break;
            }
        }
    }
    return haveAnswer;
};

/**
 * 判断分组中是否存在答案答过题
 * @param {*} group
 * @returns
 */
export const judgeGroupExistAnswer = (group = []) => {
    let haveAnswer = false;
    for (let i = 0; i < group.length; i++) {
        const question = group[i];
        // 仅对展示的题目和必填的题目校验是否有答案
        if (question.show) {
            if (question.anwser && question.anwser.length) {
                haveAnswer = true;
                break;
            }
        }
    }
    return haveAnswer;
};

/**
 * 隐藏两个页面之间所有题目
 * @param {*} page
 * @param {*} startPage
 * @param {*} endPage
 * @returns
 */
export const hideBetweenPage = (page, startPage, endPage) => {
    let nextPageKey = Number(startPage) + 1;
    while (nextPageKey < Number(endPage)) {
        const nextGroup = page[nextPageKey];
        for (let j = 0; j < nextGroup.length; j++) {
            const q = nextGroup[j];
            q.show = false;
        }
        nextPageKey += 1;
    }
    return page;
};
/**
 * 遍历当前问题的下一题开始到结束的所有题目，根据问题是否有关联关系
 * 并且根据关联关系的配置反向查找源问题是否都有满足的答案，从而判断是否显示或者隐藏
 * @param {*} currentQidentifier
 * @returns
 */
export function checkRelConfigQuestion(currentQidentifier) {
    const { page, currentPage } = store.state;
    const pageKey = Number(currentPage);
    const currentGroup = page[currentPage] || [];
    const currentIndex = findQuestionIndex(currentGroup, currentQidentifier);
    const haveRelConfigQuestionList = [];
    for (let i = currentIndex + 1; i < currentGroup.length; i++) {
        const question = currentGroup[i];
        if (haveQuestionRel(question)) {
            haveRelConfigQuestionList.push(question);
        }
    }
    let nextPageKey = pageKey + 1;
    while (page[nextPageKey]) {
        const nextGroup = page[nextPageKey];
        for (let j = 0; j < nextGroup.length; j++) {
            const q = nextGroup[j];
            if (haveQuestionRel(q)) {
                haveRelConfigQuestionList.push(q);
            }
        }
        nextPageKey += 1;
    }
    haveRelConfigQuestionList.forEach(question => {
        const isOK = checkQuestionRelOK(question);
        const { visible } = question.questionRelConfig;
        // 当前问题只是否可见：当配置确定为true或者visiable字段不存在时候都表示满足关系才可见
        const visibleFlag = visible === true || visible === undefined;
        if (isOK) {
            // 满足配置的关联关系
            question.show = visibleFlag;
        } else {
            // 不满足配置的关联关系
            question.show = !visibleFlag;
        }
    });
    return currentGroup;
}
/**
 * 根据当前题目是否有回答，判断后续题目是否应该显示
 * @param {*} currPage
 * @param {*} qidentifier
 * @param {*} answer
 */
export function checkAnswer(currPage, qidentifier) {
    const { page } = store.state;
    const group = page[currPage];
    const questions = getQuestions(page);
    const questionsCount = questions.length;
    const currQuestion = getQuestionById(qidentifier, questions);
    const { anwser } = currQuestion;
    // 如果当前没有选择答案，这要从当前题目索引是当前开始遍历题目
    // 如果有答案，则需要判断是否有跳题目逻辑(优先判断跳题目逻辑)，如有这需要从跳题目逻辑的当前题目开始遍历
    // 题目如果没有引用关系，则显示。如果有引用逻辑，需要判断基于引用逻辑题目是否显示
    // 显示后要判断是否已经选择了答案
    // 如果没有选择答案。同等逻辑遍历当前题目
    // 如果选择了答案，判断是否有跳题目逻辑，有跳题逻辑则进行逻辑跳转，并从继续从跳转目标题目继续遍历
    let startIndex = 0;
    if (anwser && anwser.length) {
        startIndex = questionJump(currQuestion);
    } else {
        startIndex = findQuestionIndex(questions, qidentifier);
    }
    // -100标识为提交无效问卷
    if (startIndex === QuestionSepcialFlag.submitInvalid) {
        return QuestionSepcialFlag.submitInvalid;
    }
    if (startIndex === questionsCount - 1) {
        return group;
    }
    for (let i = startIndex; i < questions.length; i++) {
        const question = questions[i];
        const havaRel = haveQuestionRel(question);
        if (!havaRel) {
            question.show = true;
            if (!hasAnswer(question.anwser)) {
                continue;
            } else {
                // 判断是否有跳题目逻辑
                const end = questionJump(question);
                if (end) {
                    i = end;
                }
            }
        } else {
            // 有引用逻辑，判断是否能显示
            const show = checkRefShow(question);
            question.show = show;
            if (!hasAnswer(question.anwser)) {
                continue;
            } else {
                // 判断是否有跳题目逻辑
                const end = questionJump(question);
                if (end) {
                    i = end;
                }
            }
        }
    }
    return group;
}
